import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMatch, useNavigate } from 'react-router';
import { Left } from '@linktivity/link-icons';

import Logo from '@link/shinkansen/assets/logo.svg?react';
import ShinkansenLogo from '@link/shinkansen/assets/shinkansen.png';

import styles from './header.module.css';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isSubmitted = Boolean(useMatch('/:token/:bookingId/submitted'));

  return (
    <>
      <header className={styles.inner}>
        {!isSubmitted && (
          <button
            type="button"
            className={styles.back}
            aria-label={t('common.back')}
            onClick={() => navigate(-1)}
          >
            <Left className={styles.backIcon} />
          </button>
        )}
        <Logo className={styles.logo} />
      </header>
      <div className={styles.shinkansenPanel}>
        <img className={styles.shinkansenLogo} src={ShinkansenLogo} alt="" />
      </div>
    </>
  );
};

export default Header;
